import { j as e } from "./atoms-v218.js";
import { Wrapper as p, MediaWrapper as k, ContentWrapper as c, HeaderWrapper as u, SkeletonRow as r, BodyWrapper as x } from "./atoms-v2107.js";
import { getMediaAspectRatio as o } from "./atoms-v2108.js";
import { useBreakpoints as h } from "./atoms-v251.js";
import { Picture as m } from "./atoms-v233.js";
import { Text as n } from "./atoms-v243.js";
import { CardVariant as j } from "./atoms-v2109.js";
const R = ({
  className: s,
  hasBody: a,
  hasFooter: d,
  hasHeader: l,
  variant: t = j.Standard
}) => {
  const { current: i } = h();
  return /* @__PURE__ */ e.jsxs(p, { $variant: t, "aria-hidden": "true", className: s, "data-testid": "card-skeleton", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        $isSkeleton: !0,
        $aspectRatio: o(t, i),
        $variant: t,
        children: /* @__PURE__ */ e.jsx(m, { isSkeleton: !0, aspectRatio: o(t, i) })
      }
    ),
    /* @__PURE__ */ e.jsxs(c, { $variant: t, children: [
      l && /* @__PURE__ */ e.jsx(u, { $variant: t, children: /* @__PURE__ */ e.jsx(r, { $isHeader: !0, children: /* @__PURE__ */ e.jsx(n, { isSkeleton: !0, skeletonLineCount: 1, skeletonLineHeight: 14, skeletonLineWidth: 190 }) }) }),
      /* @__PURE__ */ e.jsxs(x, { $variant: t, children: [
        a && /* @__PURE__ */ e.jsx(r, { children: /* @__PURE__ */ e.jsx(n, { isSkeleton: !0, skeletonLineCount: 1, skeletonLineHeight: 12, skeletonLineWidth: 241 }) }),
        d && /* @__PURE__ */ e.jsx(r, { children: /* @__PURE__ */ e.jsx(n, { isSkeleton: !0, skeletonLineCount: 1, skeletonLineHeight: 12, skeletonLineWidth: 120 }) })
      ] })
    ] })
  ] });
};
export {
  R as CardSkeleton
};
